import './banner-campaign.scss';
import EventBusService from '../../services/EventBusService'
import { useState, useEffect, useCallback } from 'react';
import { CAMPAIGN_STATUS, NEW_CAMPAIGN_EVENT, SHOW_MODAL_NEW_CAMPAIGN_EVENT } from '../../constants';
import LocalStorage from '../../services/local-storage';
import moment from 'moment';
import TranslateService from '../../services/translate-service';

export default function BannerCampaign() {

    const [campaign, setCampaign] = useState(LocalStorage.get(CAMPAIGN_STATUS));
    const [time, setTime] = useState('');

    const handleCampaignStatus = useCallback((event) => setCampaign(event.detail?.campaign), [])

    const formatToLeft = useCallback( () => {
        const now = moment();
        const finishDate = moment(campaign.fechaFin);

        const duration = moment.duration(finishDate.diff(now));

        let hours = Math.floor(duration.asHours());

        if (hours > 24) {
            hours = hours % 24;
        }

        let minsSec = moment(duration.asMilliseconds()).format("HH:mm:ss");

        // const days = Math.floor(finishDate.diff(now, 'days'))
        // if (days > 1) {
        //     setTime(`${days} días ${hours}:${minsSec}`)
        // } else if (days === 1) {
        //     setTime(`${days} día ${hours}:${minsSec}`)
        // } else {
        //     setTime(minsSec)
        // }
        setTime(minsSec)
    }, [campaign])

    const showModalCampaign = () => {
        EventBusService.dispatch(SHOW_MODAL_NEW_CAMPAIGN_EVENT, {})
    }

    useEffect(() => {
        EventBusService.on(NEW_CAMPAIGN_EVENT, handleCampaignStatus)

        return () => {
            EventBusService.remove(NEW_CAMPAIGN_EVENT, handleCampaignStatus)
        }
    }, [handleCampaignStatus])

    useEffect(() => {
        formatToLeft();

        const interval = setInterval(formatToLeft, 1000);

        return () => clearInterval(interval);
    }, [formatToLeft]);


    return (
        <>
            {campaign &&
                <div className="banner-campaign">
                    <div className='text-center'>
                        <p className='heading-h6' >🚵 {campaign.nombre}: {TranslateService.getAndReplace('campaign.banner.time',{time})}  <label onClick={showModalCampaign} className='link !font-normal cursor-pointer'>{TranslateService.get('campaign.banner.callToAction')}</label></p>
                    </div>
                </div>
            }
        </>

    );
}
